import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import styles from './modal.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { trackClick } from 'src/analytics/Events';
import EventNames from 'src/analytics/EventNames';
import { EventProps } from 'src/analytics/EventProps';
import { faClose } from '@fortawesome/pro-solid-svg-icons';

Modal.setAppElement('body');

type MoshModalProps = {
    children: JSX.Element;
    onModalClose: (value?: boolean) => void;
    open: boolean;
    ariaLabel?: string; // Label for the modal, string will be prefixed with Modal:
    fullscreenMobile?: boolean; // Modal takes the full screen only on Mobile
    fullscreen?: boolean; // Modal takes the full screen
    minimal?: boolean; // Modal adapts to content size within
    custom?: boolean; // Modal adapts to content size within
    className?: string;
    overlayClassName?: string;
    eventProps?: EventProps;
    theme?: string;
};

const MoshModal = (props: MoshModalProps) => {
    const [modalIsOpen, setIsOpen] = useState(false);
    useEffect(() => {
        setIsOpen(props.open);
        props.open &&
            trackClick(EventNames.MODAL_OPENED, { ...props.eventProps });
    }, [props.open, props.eventProps]);

    function closeModal() {
        setIsOpen(false);
        props.onModalClose?.(false);
    }

    return (
        <>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => closeModal()}
                contentLabel={'Modal: ' + props.ariaLabel}
                className={classNames(
                    styles['window'],
                    props.fullscreen && styles['full'],
                    props.minimal && styles['minimal'],
                    props.fullscreenMobile && styles['full-mobile'],
                    props.custom && styles['custom'],
                    props.overlayClassName,
                    props.theme ? props.theme : '',
                )}
                overlayClassName={classNames(
                    styles['overlay'],
                    props.theme ? props.theme : '',
                )}
            >
                <div
                    className={classNames(
                        styles['content'],
                        props.className,
                        props.theme ? props.theme : '',
                    )}
                    data-modal-content
                >
                    {props.children}
                </div>
                <button
                    aria-label="close"
                    onClick={closeModal}
                    className={styles['close']}
                >
                    <FontAwesomeIcon icon={faClose} className="w-4 h4" />
                </button>
            </Modal>
        </>
    );
};

export default MoshModal;
